module.exports = __webpack_public_path__ + "static/media/distretto-militare-di-reggio-emilia.f7ca0de8.svg";